module.exports = "const x: i32 = 2;\nexport function echo(): i32 {\n  const x: i32 = 42;\n  return x;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./examples/walt/default.walt
// module id = 921
// module chunks = 0